/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Reset_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to log in. Please try again." |
*
* @param {Auth_Reset_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_reset_error = /** @type {((inputs?: Auth_Reset_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Reset_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Anmeldung fehlgeschlagen. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Failed to log in. Please try again.")
});